import React from 'react';
import ButtonBase from 'components/Models/ButtonBase/ButtonBase';
import Icon from 'components/Icon';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './InvestorLinkButton.scss';

const themes = {
    ghost: 'ghost',
    light: 'light'
};

const InvestorLinkButton = ({
    className,
    openInNewWindow = false,
    url,
    text,
    tabindex,
    iconName,
    rightIconName,
    download,
    theme = themes.light,
    isActive,
    iconOnlyOnTablet,
    onClick,
}) => {
    const RootTag = url ? 'a' : 'button';

    return (
        <RootTag
            href={url}
            className={cn('investor-link-button', {
                [className]: className,
                [`investor-link-button_theme-${theme}`]: theme,
                ['investor-link-button_active']: isActive,
                ['investor-link-button_icon-only-mobile']: iconOnlyOnTablet
            })}
            target={openInNewWindow ? '_blank' : null}
            rel={openInNewWindow ? 'nofollow noopener' : null}
            tabIndex={tabindex}
            download={download}
            onClick={onClick}
        >
            {iconName && (
                <Icon icon={iconName} className="investor-link-button__icon" />
            )}
            <span 
                className={cn("investor-link-button__text", {
                    "hidden-mobile-and-tablet": iconOnlyOnTablet
                })}
            >
                {text}
            </span>
            {rightIconName && (
                <Icon icon={rightIconName} className="investor-link-button__icon investor-link-button__icon_right" />
            )}
        </RootTag>
    );
};

InvestorLinkButton.propTypes = Object.assign({}, ButtonBase.propTypes, {
    download: PropTypes.bool,
    className: PropTypes.string,
    iconName: PropTypes.string,
    theme: PropTypes.oneOf(Object.values(themes)),
    rightIconName: PropTypes.string,
    isActive: PropTypes.bool,
    iconOnlyOnTablet: PropTypes.bool,
    onClick: PropTypes.func
});

export default InvestorLinkButton;



// WEBPACK FOOTER //
// ./src/components/InvestorLinkButton/InvestorLinkButton.jsx